"use client";
import React, { useState } from "react";
import { Drawer } from "vaul";

export function ConfirmDrawer({ title, text, confirmText = "Da, șterge", onConfirm, onCancel }) {
	return (
		<Drawer.Root open onOpenChange={(open) => !open && onCancel()}>
			<Drawer.Portal>
				<Drawer.Overlay className='tf-review-drawer-overlay' />
				<Drawer.Content className='tf-review-drawer-content'>
					<Drawer.Handle />
					<div className='tf-review-drawer-body'>
						<Drawer.Title className='tf-review-drawer-title'>{title}</Drawer.Title>
						{text && <p className='tf-review-confirm-text'>{text}</p>}
						<div className='tf-review-confirm-actions'>
							<button type='button' className='tf-review-confirm-cancel' onClick={onCancel}>
								Anulează
							</button>
							<button type='button' className='tf-review-confirm-danger' onClick={onConfirm}>
								{confirmText}
							</button>
						</div>
					</div>
				</Drawer.Content>
			</Drawer.Portal>
		</Drawer.Root>
	);
}

export function EditTextDrawer({ title, initialValue = "", onSave, onCancel }) {
	const [value, setValue] = useState(initialValue);

	return (
		<Drawer.Root open onOpenChange={(open) => !open && onCancel()}>
			<Drawer.Portal>
				<Drawer.Overlay className='tf-review-drawer-overlay' />
				<Drawer.Content className='tf-review-drawer-content'>
					<Drawer.Handle />
					<div className='tf-review-drawer-body'>
						<Drawer.Title className='tf-review-drawer-title'>{title}</Drawer.Title>
						<textarea className='tf-review-edit-textarea' rows={4} value={value} onChange={(e) => setValue(e.target.value)} />
						<div className='tf-review-confirm-actions'>
							<button type='button' className='tf-review-confirm-cancel' onClick={onCancel}>
								Anulează
							</button>
							<button type='button' className='tf-review-confirm-save' onClick={() => onSave(value)}>
								Salvează
							</button>
						</div>
					</div>
				</Drawer.Content>
			</Drawer.Portal>
		</Drawer.Root>
	);
}
